<template>
  <footer>
    <div class="h-4 bg-4y-sonny-yellow" />
    <div class="h-4 bg-4y-somesky-blue" />
    <div class="px-4 bg-4y-sky-blue lg:px-10 xl:px-20 py-9">
      <div class="container">
        <nav class="w-full">
          <ul class="flex flex-wrap text-sm md:flex-nowrap md:flex-row">
            <li class="w-1/2 pb-4 pr-2 text-white md:w-auto md:pb-0 md:pr-6 xl:pr-12">
              <router-link :to="$i18nTo({ name: 'imprint' })" class="inline-flex items-center hover:underline footer-link">
                <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'mr-2 h-3 w-3 text-white'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.68 5.531V4.22h6.125L4.303 1.73 5.246.8 9.32 4.876 5.246 8.949l-.943-.93 2.502-2.488H.68z" fill="#fff"/></svg>
                <span class="pt-0.5">{{ tr('components.footer.links.imprint') }} </span>
              </router-link>
            </li>
            <li class="w-1/2 pb-4 -ml-3 md:ml-0 pr-2 text-white md:w-auto md:pb-0 md:pr-6 xl:pr-12">
              <router-link :to="$i18nTo({ name: 'termsOfUse' })" class="inline-flex hover:underline items-center footer-link">
                <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'mr-2 h-3 w-3 text-white'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.68 5.531V4.22h6.125L4.303 1.73 5.246.8 9.32 4.876 5.246 8.949l-.943-.93 2.502-2.488H.68z" fill="#fff"/></svg>
                <span class="pt-0.5">{{ tr('components.footer.links.termsAndConditions') }}</span>
              </router-link>
            </li>
            <li class="w-1/2 pb-4 pr-2 text-white md:w-auto md:pb-0 md:pr-6 xl:pr-12">
              <a :href="privacyLink" target="_blank" class="inline-flex hover:underline items-center footer-link">
                <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'mr-2 h-3 w-3 text-white'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.68 5.531V4.22h6.125L4.303 1.73 5.246.8 9.32 4.876 5.246 8.949l-.943-.93 2.502-2.488H.68z" fill="#fff"/></svg>
                <span class="pt-0.5">{{ tr('components.footer.links.privacy') }}</span>
              </a>
            </li>
            <li class="w-1/2 pb-4 pr-2 -ml-3 md:ml-0 text-white md:w-auto md:pb-0 md:pr-6 xl:pr-12">
              <router-link :to="$i18nTo({ name: 'faq' })" class="inline-flex hover:underline items-center footer-link">
                <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'mr-2 h-3 w-3 text-white'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.68 5.531V4.22h6.125L4.303 1.73 5.246.8 9.32 4.876 5.246 8.949l-.943-.93 2.502-2.488H.68z" fill="#fff"/></svg>
                <span class="pt-0.5">{{ tr('components.footer.links.faq') }}</span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="px-4 py-2 lg:px-10 xl:px-20 xl:py-2 bg-4y-darksky-blue">
      <div class="container">
        <div class="flex flex-col items-center justify-between w-full md:flex-row">
          <div class="pb-4 md:pb-0">
            <img
              src="~images/discover/logos/discover_airlines_rgb_white_1line.svg"
              class="w-48 -ml-3"
              alt="Discover Airlines Logo"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="h-10 bg-4y-nightsky-blue" />
  </footer>
</template>

<script lang="ts">
import Footer from '~brand-components/base/shared/footer'

export default Footer.extend({

  computed: {
    privacyLink() {
      if (this.$i18n.locale === 'de') {
        return 'https://www.lufthansa.com/de/de/datenschutz'
      }

      return 'https://www.lufthansa.com/de/en/datenschutz'
    },
  },
})
</script>

<style lang="scss" scoped>
.footer-link {
  &:focus {
    outline: 1px solid white;
    outline-offset: 3px;
  }
}
</style>
